import { DeviceFieldValues, getDeviceFields } from "@services/catalog";
import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { displayCountryName, sfcountries } from "@assets/countries";
import { useTranslation } from "react-i18next";

export type DeviceFieldContextType = DeviceFieldValues & {
  countries: [];
};

const defaultValues: DeviceFieldContextType = {
  countries: [],
  manufacturers: [],
  deviceTypes: [],
  categories: [],
};
export const FieldValueContext =
  createContext<DeviceFieldContextType>(defaultValues);

export const FieldValueProvider = (props: PropsWithChildren<{}>) => {
  const [fieldValues, setFieldValues] = useState<DeviceFieldValues>();
  const { t } = useTranslation();
  defaultValues.countries = sfcountries.map((country) => {
    return {
      key: country.alpha2,
      label: displayCountryName(country, t),
    };
  }) as [];
  const refetch = async () => {
    try {
      setFieldValues(await getDeviceFields());
    } catch (e) {}
  };

  useEffect(() => {
    refetch();
  }, []);

  return (
    <FieldValueContext.Provider value={{ ...defaultValues, ...fieldValues }}>
      {props.children}
    </FieldValueContext.Provider>
  );
};
